import { en } from './en.js'

export const ja = structuredClone(en)

ja.visualGameAdmin.conversionFunnelDevices = {'label': 'アクセス元のデバイス', 'all': 'すべて', 'desktop': 'パソコン', 'mobile': 'スマートフォン', 'tablet': 'タブレット'}

ja.visualGameAdmin.pageFunnel = {'button': 'ページファネル', 'title': 'ページファネル', 'home': 'ホーム', 'auth': 'ログイン・登録入口', 'game': 'ゲームページ', 'note': '選択期間・デバイスで順番に各段階に到達したセッション数。ログインにはPCのログイン・登録ダイアログを含みます。過去の未記録データは集計できません。', 'loading': '読み込み中…', 'error': '読み込み失敗', 'sessions': 'セッション'}

ja.visualGameAdmin.pageFunnel.viewUsers = 'ユーザーを見る'
ja.visualGameAdmin.pageFunnel.peopleUnit = '人'
ja.visualGameAdmin.pageFunnel.timesUnit = '回'

ja.visualGameAdmin.pageFunnel.userFilter_all = 'ファネル：登録・ログイン'

ja.visualGameAdmin.pageFunnel.userFilter_sign_up = 'ファネル：期間内の登録ユーザー'

ja.visualGameAdmin.pageFunnel.userFilter_login = 'ファネル：期間内のログインユーザー'

ja.visualGameAdmin.usageActivity = {
  "title": "サイト利用 · 行動明細",
  "button": "明細を見る",
  "all": "すべての行動",
  "search": "ユーザー、ゲーム、記録 ID を検索",
  "user": "ユーザー",
  "game": "ゲーム",
  "kind": "行動",
  "status": "状態",
  "time": "日時",
  "detail": "記録を見る",
  "empty": "該当する記録はありません",
  "loading": "読み込み中…",
  "error": "読み込み失敗",
  "note": "入力記録は独自イベントに基づくため GA4 と異なる場合があります。未記録の入力内容やプレイ ID は推測しません。",
  "limit": "最新 1000 件を表示。期間を絞ると他の記録を確認できます。",
  "text_input": "文字入力",
  "voice_input": "音声入力",
  "slice_video": "シーン動画生成",
  "global_video": "全体動画生成",
  "free_game": "無料ゲーム生成"
}

Object.assign(ja.visualGameAdmin.usageActivity, {
  "status_queued": "待機中",
  "status_running": "生成中",
  "status_ready": "完了",
  "status_failed": "失敗",
  "status_submitting": "送信中",
  "status_submitted": "送信済み",
  "status_ok": "成功",
  "status_error": "失敗",
  "status_generating": "生成中",
  "status_generation_failed": "生成失敗",
  "status_pending_review": "審査待ち",
  "status_review_rejected": "却下",
  "status_published": "公開済み",
  "status_archived": "アーカイブ済み"
})

ja.visualGameAdmin.usageActivity.records = '件'

ja.visualGameAdmin.paypointActivity = {
  "title": "課金ポイント · 発生明細",
  "all": "すべて",
  "game": "ページ",
  "kind": "課金場面",
  "status": "発生理由",
  "note": "独自イベントは GA4 と異なる場合があります。動画ダイアログの表示はポイント不足を意味しません。過去の記録には必要ポイント、残高、プレイ ID がありません。",
  "billing_paypoint_gameplay": "プレイ",
  "billing_paypoint_ending_video": "エンディング動画",
  "billing_paypoint_story_video": "ストーリー動画",
  "status_insufficient_balance": "プレイのポイント不足",
  "status_dialog_open": "生成ダイアログ表示"
}

ja.visualGameAdmin.paypointActivity.search = 'ユーザー、ページ、記録 ID を検索'

ja.visualGameAdmin.orderDrilldown = {
  "button": "注文を見る",
  "dateField": "日時の基準",
  "created_at": "作成日時",
  "paid_at": "支払日時"
}

Object.assign(ja.visualGameAdmin.orderDrilldown, {
  "since": "開始日時",
  "until": "終了日時"
})

ja.visualGameAdmin.orderDrilldown.updated_at = 'ステータス更新日時'

ja.visualGameAdmin.trafficBaseline = {
  "confirmed": "確認済み増分",
  "first": "初回観測再生数（未確認）",
  "missing": "基準値不足・増分は不完全",
  "note": "期間前の記録がない場合、初回観測再生数は確認済み増分に含めません。初回観測日は公開日ではありません。",
  "observed": "初回観測日",
  "filter": "基準値不足",
  "unchanged": "増加なし（基準値あり）",
  "later": "初回観測後の増加"
}

ja.visualGameAdmin.funnelAuth = {
  registration: 'サイト登録',
  login: 'サイトログイン',
  new_users: '新規ユーザーのログイン',
  existing_users: '既存ユーザーのログイン',
  note: '新規ユーザーは選択期間内の登録、既存ユーザーは期間開始前の登録です。登録成功後の自動ログインを含みます。人数は重複を除き、回数は自動ログインとその後の成功ログインを含みます。登録とログインは重複するため合算しません。',
  user_type: 'ユーザー種別',
  registered_at: '登録日時',
  new_type: '新規ユーザー',
  existing_type: '既存ユーザー',
  auto_login: '登録後の自動ログイン'
}

ja.visualGameAdmin.funnelPeriods = {
  yesterday: '昨日',
  last_three_days: '直近3日間'
}

ja.visualGameAdmin.videoExport = {
  button: '現在の一覧をCSV出力',
  published_sort: '公開日時順',
  published_label: '公開日時',
  unknown: '未記録'
}
